import { graphql } from "@/gql";

export const createBookingMutation = graphql(`
  mutation CreateBooking($input: CreateBookingInput!) {
    createBooking(input: $input) {
      id
    }
  }
`);

export const updateBookingMutation = graphql(`
  mutation UpdateBooking($id: ID!, $input: UpdateBookingInput!) {
    updateBooking(id: $id, input: $input) {
      id
    }
  }
`);

export const mailBookingToCustomerMutation = graphql(`
  mutation MailBookingToCustomer($id: ID!) {
    mailBookingToCustomer(id: $id) {
      id
    }
  }
`);

export const mailBookingToSupplierMutation = graphql(`
  mutation MailBookingToSupplier(
    $id: ID!
    $emails: [String!]
    $event: SupplierNotificationSettingEvent
  ) {
    mailBookingToSupplier(id: $id, emails: $emails, event: $event) {
      id
    }
  }
`);

export const mailBookingToAdminMutation = graphql(`
  mutation MailBookingToAdmin($id: ID!) {
    mailBookingToAdmin(id: $id) {
      id
    }
  }
`);

export const bookingReleaseLineMutation = graphql(`
  mutation BookingReleaseLine($id: ID!) {
    bookingReleaseLineReference(id: $id) {
      id
    }
  }
`);

export const bookingChangeRelocationMutation = graphql(`
  mutation BookingChangeRelocation(
    $id: ID!
    $input: BookingChangeRelocationInput!
  ) {
    bookingChangeRelocation(id: $id, input: $input) {
      id
    }
  }
`);

export const bookingAcceptedMutation = graphql(`
  mutation AcceptBooking($id: ID!) {
    acceptBooking(id: $id) {
      id
    }
  }
`);

export const createAdminBookingPaymentIntentMutation = graphql(`
  mutation CreateAdminBookingPaymentIntent(
    $id: ID!
    $input: CreateAdminBookingPaymentIntentInput!
  ) {
    createAdminBookingPaymentIntent(id: $id, input: $input) {
      id
      client_secret
      amount
      currency
    }
  }
`);
